import styled from 'styled-components';
import { ScreenWrapper } from '@CS/app/App.styles';

export default styled(ScreenWrapper)`
  padding: 0 clamp(20px, 6.667vmin, 30px);
  justify-content: space-evenly;
  background-color: white;
`;
